<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M4.57,0A2.26,2.26,0,0,0,3,.67,2.28,2.28,0,0,0,3,3.9a2.26,2.26,0,0,0,1.61.67A22.85,22.85,0,0,1,27.43,27.43a2.29,2.29,0,0,0,2.28,2.28A2.29,2.29,0,0,0,31.33,29,2.26,2.26,0,0,0,32,27.43,27.43,27.43,0,0,0,4.57,0Z" />
    <path d="M4.57,22.86A4.58,4.58,0,1,0,7.8,24.2,4.56,4.56,0,0,0,4.57,22.86Z" />
    <path
        d="M4.57,11.43a2.29,2.29,0,0,0-2.28,2.28A2.29,2.29,0,0,0,3,15.33,2.26,2.26,0,0,0,4.57,16,11.44,11.44,0,0,1,16,27.43,2.26,2.26,0,0,0,16.67,29a2.28,2.28,0,0,0,3.23,0,2.26,2.26,0,0,0,.67-1.61,16,16,0,0,0-16-16Z" />
</svg>
